import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "adapt-root",
    templateUrl: "./app.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AppComponent {
    public title = "outlook-addin";
}
